







































import { defineComponent, reactive, computed } from '@vue/composition-api'
import TalkCard from '@/components/TalkCard.vue'
import { THEME_COLLOR, STYLE_COLOR, THEME_SHADOW, STYLE_SHADOW } from '@/Colors'
import cards from '../assets/cards.json'
import { randomFrom, wait } from '@/lib/utils'
import CountDown from '@/components/CountDown.vue'

export default defineComponent({
  components: {
    TalkCard,
    CountDown
  },
  props: {},
  setup () {
    const cardState = reactive({
      themeCard: {
        text: '100にん//あつまったら//できそうなこと',
        color: THEME_COLLOR,
        shadow: THEME_SHADOW,
        isOpen: false,
        isFlipping: false
      },
      styleCard: {
        text: 'ゆ〜っくり//しゃべってみよう',
        color: STYLE_COLOR,
        shadow: STYLE_SHADOW,
        isOpen: false,
        isFlipping: false
      }
    })
    const timerState = reactive({
      time: 0,
      isActive: false,
      isPopping: false
    })

    const isCardOpen = computed(() => cardState.themeCard.isOpen || cardState.styleCard.isOpen)
    const isAllCardOpen = computed(() => cardState.themeCard.isOpen && cardState.styleCard.isOpen)
    const isTimeup = computed(() => timerState.isActive && timerState.time === 0)

    const openCard = async (isTheme = true, isStyle = true) => {
      if (isTheme) {
        cardState.themeCard.text = randomFrom(cards.themes)
        cardState.themeCard.isOpen = true
        cardState.themeCard.isFlipping = true
        await wait(300)
        cardState.themeCard.isFlipping = false
        await wait(250)
      }
      if (isStyle) {
        cardState.styleCard.text = randomFrom(cards.styles)
        cardState.styleCard.isOpen = true
        cardState.styleCard.isFlipping = true
        await wait(300)
        cardState.styleCard.isFlipping = false
        await wait(250)
      }
    }

    const closeCard = async (isTheme = true, isStyle = true) => {
      if (isTheme && cardState.themeCard.isOpen) {
        cardState.themeCard.isOpen = false
        cardState.themeCard.isFlipping = true
        await wait(300)
        cardState.themeCard.isFlipping = false
      }
      if (isStyle && cardState.styleCard.isOpen) {
        cardState.styleCard.isOpen = false
        cardState.styleCard.isFlipping = true
        await wait(300)
        cardState.styleCard.isFlipping = false
      }
      if (!isAllCardOpen.value) {
        timerState.time = 0
        timerState.isActive = false
      }
    }

    const setNewCard = async () => {
      if (isCardOpen.value) {
        await closeCard()
        await wait(500)
      }
      await openCard()
    }

    const clickThemeCard = () => {
      if (cardState.themeCard.isOpen) { return }
      openCard(true, false)
    }

    const clickStyleCard = () => {
      if (cardState.styleCard.isOpen) { return }
      openCard(false, true)
    }

    const startCount = async () => {
      timerState.time = 20
      timerState.isActive = true
      await wait(0)
      timerState.isPopping = true
      await wait(250)
      timerState.isPopping = false
    }

    return {
      cardState,
      isCardOpen,
      isAllCardOpen,
      isTimeup,
      setNewCard,
      openCard,
      closeCard,
      clickThemeCard,
      clickStyleCard,
      timerState,
      startCount
    }
  }
})
